module.exports = "./img/0f80a619404c4c1db343098e6973f591.png";